import "./screenHeader.scss";

// Reusable V2 screen header: brand-colored bar, centered title, back chevron
// (default) or close X (variant="close") at the inline-start (right in RTL).
// variant="none" drops the control entirely — for screens with nowhere to go
// back to, like the home page.
function ScreenHeader({ title, onBack, variant = "back" }) {
  return (
    <header className="v2-screen-header">
      {variant === "none" ? (
        <span className="v2-screen-header-spacer" />
      ) : (
        <button
          type="button"
          className="v2-screen-header-back"
          onClick={onBack}
          aria-label={variant === "close" ? "close" : "back"}
        >
          {variant === "close" ? (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 1L9 8L2 15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </button>
      )}
      <p className="v2-screen-header-title">{title}</p>
      <span className="v2-screen-header-spacer" />
    </header>
  );
}

export default ScreenHeader;
